export default "__VITE_PUBLIC_ASSET__854915f2__"